import { TradingCardSkeleton as PUITradingCardSkeleton } from "@pepperstone/pepper-ui-kit";

export const TradingCardSkeleton = () => {
  //because we override this, everytime we need to upgrade pepper-ui-kit we need to check on this
  return (
    // oxlint-disable-next-line partners-custom-rule/no-ps-classnames
    <div className="w-full [&_.ps-animate-pulse]:!bg-blue-845 [&_.ps-w-account-card]:!bg-surface-emphasis">
      <PUITradingCardSkeleton />
    </div>
  );
};
